export enum ApiStatus {
  OK = 0,

  RECAPTCHA_TOKEN_FAILED = 100,
  EMAIL_SENT_FAILED = 101,
  ADMIN_SUPERUSER_EXISTS = 1000,
  ADMIN_USER_NOT_FOUND = 1001,
  ADMIN_USER_PASSWORD_INCORRECT = 1002,
  ADMIN_USER_BANNED = 1003,
  ADMIN_CAPTCHA_INCORRECT = 1004,

  USER_EMAIL_NOT_FOUND = 1007,
  USER_PASSWORD_INCORRECT = 1008,
  USER_BANNED = 1009,
  USER_EMAIL_DUPLICATED = 1010,
  USER_EMAIL_VERIFIED = 1011,
  USER_EMAIL_NOT_VERIFIED = 1012,
  USER_EMAIL_SEND_TOO_FREQUENTLY = 1013,

  USER_EMAIL_TOKEN_NOT_FOUND = 1014,
  USER_EMAIL_TOKEN_USED = 1015,
  USER_EMAIL_TOKEN_EXPIRED = 1016,

  ROUTE_NOT_FOUND = 1100,
  API_EXISTS = 1101,
  API_NOT_FOUND = 1102,
  PERMISSION_NOT_FOUND = 1103,
  PERMISSION_CODE_DUPLICATED = 1104,
  PERMISSION_PARENT_INVALID = 1105,

  PRODUCT_CATEGORY_NAME_DUPLICATED = 1200,
  PRODUCT_CATEGORY_NO_DUPLICATED = 1201,
  PRODUCT_CATEGORY_NOT_FOUND = 1202,

  PRODUCT_NO_DUPLICATED = 1203,
  PRODUCT_URL_DUPLICATED = 1204,
  PRODUCT_URL_INVALID = 1205,
  PRODUCT_ATTR_INVALID = 1206,
  PRODUCT_NOT_FOUND = 1207,
  PRODUCT_COLLECTION_NOT_FOUND = 1208,
  PRODUCT_COLLECTION_NO_DUPLICATED = 1209,

  SHOPPING_CART_EMPTY = 1300,
  PAYMENT_INTENT_NOT_FOUND = 1301,
}

export class ApiException extends Error {
  status: number;
  data: any;

  constructor(status: number, data?: any) {
    super(`ApiException: ${status}`);
    this.data = data;
    this.name = 'ApiException';
    this.status = status;

    // 👇 让 TypeScript 正确识别为 ApiException
    Object.setPrototypeOf(this, ApiException.prototype);
  }
}
